import { render, staticRenderFns } from "./LayoutFloating.vue?vue&type=template&id=389cbef3&scoped=true"
import script from "./LayoutFloating.vue?vue&type=script&lang=js"
export * from "./LayoutFloating.vue?vue&type=script&lang=js"
import style0 from "./LayoutFloating.vue?vue&type=style&index=0&id=389cbef3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389cbef3",
  null
  
)

export default component.exports